export const SUBMISSION_TYPE_UPLOAD = 'upload';
export const SUBMISSION_TYPE_URL = 'url';

// Submission format types - used in submission_formats JSONB array
export const SUBMISSION_FORMAT_SPREADSHEET = 'spreadsheet';
export const SUBMISSION_FORMAT_PDF = 'pdf';
export const SUBMISSION_FORMAT_ZIP = 'zip';
export const SUBMISSION_FORMAT_PRESENTATION_LINK = 'presentation_link';
export const SUBMISSION_FORMAT_GITHUB_LINK = 'github_link';
export const SUBMISSION_FORMAT_GENERIC_LINK = 'generic_link';
